import { Invitee } from 'modules/calendar/core/type';
import {
  Avatar,
  AvatarContainer,
  InviteeInfo,
  InviteeItem,
  InviteeName,
  ScheduleOverlap,
  StatusIcon,
} from 'modules/calendar/styles/invitee-selector';

import { ReactComponent as AvatarCircleIcon } from 'assets/icons/avatar.svg';
import { ReactComponent as CloseCircleIcon } from 'assets/icons/close-circle-red.svg';
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';
import { ReactComponent as CheckCircleIcon } from 'assets/icons/tick-green.svg';

import { isEmpty } from 'lodash';
import { isNil } from 'lodash';

export const InviteeListItem = ({
  invitee,
  isRemovable = false,
  onRemove,
}: {
  invitee: Invitee;
  isRemovable?: boolean;
  onRemove?: () => void;
}) => (
  <InviteeItem
    key={invitee.id}
    isSelected={false}
    className="ml-16"
    style={{
      maxWidth: 230,
      background: 'none',
      cursor: 'default',
      maxHeight: 38,
    }}
  >
    <AvatarContainer>
      {isNil(invitee.avatar) || isEmpty(invitee.avatar) ? (
        <AvatarCircleIcon style={{ width: 32, height: 32 }} />
      ) : (
        <Avatar src={invitee.avatar} alt={invitee.name} />
      )}

      {invitee.status === 'yes' && (
        <StatusIcon>
          <CheckCircleIcon />
        </StatusIcon>
      )}

      {invitee.status === 'no' && (
        <StatusIcon>
          <CloseCircleIcon />
        </StatusIcon>
      )}
    </AvatarContainer>

    <div className={isRemovable ? 'flex items-center gap-6 cursor-pointer' : ''}>
      <InviteeInfo style={{ maxWidth: 180 }}>
        <InviteeName className="ellipsis">{invitee.name}</InviteeName>
        {invitee.hasScheduleOverlap && <ScheduleOverlap>Schedule overlap</ScheduleOverlap>}
      </InviteeInfo>
      {isRemovable && onRemove && <CloseIcon onClick={onRemove} />}
    </div>
  </InviteeItem>
);
